module.exports = __webpack_public_path__ + "static/scale-model-of-sparks-heritage-museum-in-reno-nevada-5b6b9ef35624fd227a081d0060a8333d.png";